<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>
    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      small
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id, data.item.type)"
          >
            {{ data.value.id }}VIEW
          </b-button>
        </span>
      </template>
      <template v-slot:cell(month)="data">
        <span v-if="data.value == 1">January</span>
        <span v-if="data.value == 2">February</span>
        <span v-if="data.value == 3">March</span>
        <span v-if="data.value == 4">April</span>
        <span v-if="data.value == 5">May</span>
        <span v-if="data.value == 6">June</span>
        <span v-if="data.value == 7">July</span>
        <span v-if="data.value == 8">August</span>
        <span v-if="data.value == 9">September</span>
        <span v-if="data.value == 10">October</span>
        <span v-if="data.value == 11">November</span>
        <span v-if="data.value == 12">December</span>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
      v-if="!isLoading"
    ></b-pagination>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      filter2: null,
      indexsearch: 1,
      form: {
        name: null,
        page: 1
      },
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Name", value: "1" }
        ]
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },

      isLoading: false
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    if (this.type === "sub" && this.tab !== "5") {
      this.getMFSub();
      return;
    }

    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.name = this.name !== "null" ? this.name : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        if (this.type === "main") {
          this.getMF();
        } else if (this.type === "sub") {
          this.getMFSub();
        }
      }
    } else {
      if (this.type === "main") {
        this.getMF();
      } else if (this.type === "sub") {
        this.getMFSub();
      }
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },

    state: {
      type: Number,
      required: false
    },

    type: {
      type: String,
      required: true
    },

    user_id: {
      type: Number
    },

    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    name: {
      type: String
    },
    tab: {
      type: String
    }
  },
  methods: {
    onClickView(id) {
      if (this.type === "sub") {
        this.$router.push({
          path: `viewMF?id=${id}&cat=3&type=${this.type}&state=${this.state}&upline=${this.user_id}&page=${this.pagination.current}&filter=${this.filter2}&name=${this.form.name}&date=null&outlet_name=null&email=null`
        });
      } else {
        this.$router.push({
          path: `viewMF?id=${id}&cat=3&page=${this.pagination.current}&filter=${this.filter2}&name=${this.form.name}`
        });
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getMF() {
      this.isLoading = true;
      this.items = [];
      let url = `page=${this.pagination.current}`;
      this.$store.dispatch("getMF", url).then(res => {
        this.isLoading = false;
        res.data.data.data.forEach(element => {
          this.items.push({
            month: element.month,
            name: element.userdetails !== null ? element.userdetails.name : "",
            status: element.status,
            id: element.fc_id,
            type: element.type
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },

    getMFSub() {
      this.items = [];
      this.isLoading = true;

      let url = `user/downlinestock/monthlyfor?user_id=${this.user_id}&page=${this.pagination.current}`;
      this.$store.dispatch("getMFSubDAdmin", url).then(res => {
        this.isLoading = false;
        res.data.data.data.forEach(element => {
          this.items.push({
            month: element.month,
            name: element.userdetails !== null ? element.userdetails.name : "",
            status: element.status,
            id: element.fc_id,
            type: element.type
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },

    onClickSearch() {
      // let page = this.pagination.current !== this.pagination.startIndex ? this.pagination.startIndex : this.pagination.current
      this.form.page = this.indexsearch;
      if (this.filter2 === null) {
        if (this.type === "main") {
          this.getMF();
        } else if (this.type === "sub") {
          this.getMFSub();
        }
      } else {
        if (this.type === "main") {
          this.isLoading = true;
          this.$store.dispatch("searchMF", this.form).then(res => {
            this.isLoading = false;
            this.items = [];
            res.data.data.data.forEach(element => {
              this.items.push({
                month: element.month,
                name:
                  element.userdetails !== null ? element.userdetails.name : "",
                status: element.status,
                id: element.fc_id,
                type: element.type
              });
            });
            this.pagination.total = res.data.data.total;
            this.pagination.current = res.data.data.current_page;
            this.pagination.perPage = res.data.data.per_page;
            this.pagination.startIndex = res.data.data.from;
            this.indexsearch = res.data.data.current_page;
          });
        } else if (this.type === "sub") {
          this.isLoading = true;
          let url = `user/downlinestock/monthlyfor?user_id=${this.user_id}&page=${this.pagination.current}&name=${this.form.name}`;

          this.$store.dispatch("getMFSubDAdmin", url).then(res => {
            this.isLoading = false;
            this.items = [];
            res.data.data.data.forEach(element => {
              this.items.push({
                month: element.month,
                name:
                  element.userdetails !== null ? element.userdetails.name : "",
                status: element.status,
                id: element.fc_id,
                type: element.type
              });
            });
            this.pagination.total = res.data.data.total;
            this.pagination.current = res.data.data.current_page;
            this.pagination.perPage = res.data.data.per_page;
            this.pagination.startIndex = res.data.data.from;
            this.indexsearch = res.data.data.current_page;
          });
        }
      }
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        if (this.type === "main") {
          this.getMF();
        } else if (this.type === "sub") {
          this.getMFSub();
        }
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        // this.indexsearch++
        this.onClickSearch();
      }
    },
    resetFilter() {
      this.form.name = null;
    },
    resetIndex() {
      this.indexsearch = 1;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.name = null;
      this.form.state = null;
      this.pagination.current = 1;
      if (this.type === "main") {
        this.getMF();
      } else if (this.type === "sub") {
        this.getMFSub();
      }
    }
  }
};
</script>
<style lang="css" scoped></style>
